import React from 'react';

const ListingStats = ({ listings, pagination, filters }) => {
  const stats = {
    total: pagination.total,
    pending: listings.filter(l => l.moderation_status === 'pending').length,
    approved: listings.filter(l => l.moderation_status === 'approved').length,
    rejected: listings.filter(l => l.moderation_status === 'rejected').length,
    active: listings.filter(l => l.status === 'active').length,
    inactive: listings.filter(l => l.status === 'inactive').length,
    sold: listings.filter(l => l.status === 'sold').length,
    featured: listings.filter(l => l.is_featured).length,
    boosted: listings.filter(l => l.has_active_boost || l.is_boosted).length,
    withReports: listings.filter(l => l.admin_stats?.report_count > 0).length,
  };
  
  const getStatCards = () => [
    { 
      title: 'Total Listings', 
      value: stats.total, 
      icon: '📦', 
      color: 'text-white', 
      bgColor: 'bg-gray-800',
      borderColor: 'border-gray-700',
      iconBg: 'bg-gray-700',
      progressBar: true
    },
    { 
      title: 'Pending Review', 
      value: stats.pending, 
      icon: '⏳', 
      color: 'text-yellow-300', 
      bgColor: 'bg-yellow-900/30',
      borderColor: 'border-yellow-800',
      iconBg: 'bg-yellow-800',
      highlight: filters.moderation_status === 'pending'
    },
    { 
      title: 'Active', 
      value: stats.active, 
      icon: '✅', 
      color: 'text-green-400', 
      bgColor: 'bg-green-900/30',
      borderColor: 'border-green-800',
      iconBg: 'bg-green-800'
    },
    { 
      title: 'Featured', 
      value: stats.featured, 
      icon: '⭐', 
      color: 'text-purple-400', 
      bgColor: 'bg-purple-900/30',
      borderColor: 'border-purple-800',
      iconBg: 'bg-purple-800'
    },
    { 
      title: 'Boosted', 
      value: stats.boosted, 
      icon: '🚀', 
      color: 'text-[#ff660e]', 
      bgColor: 'bg-[#ff660e]/10',
      borderColor: 'border-[#ff660e]/30',
      iconBg: 'bg-[#ff660e]/20'
    },
    { 
      title: 'With Reports', 
      value: stats.withReports, 
      icon: '⚠️', 
      color: 'text-red-400', 
      bgColor: 'bg-red-900/30',
      borderColor: 'border-red-800',
      iconBg: 'bg-red-800'
    },
  ];
  
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {getStatCards().map((stat, index) => (
        <div 
          key={index}
          className={`rounded-xl border p-4 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] group ${stat.bgColor} ${stat.borderColor}`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`p-2 rounded-lg transition-transform group-hover:scale-110 ${stat.iconBg}`}>
              <span className="text-xl">{stat.icon}</span>
            </div>
            {stat.highlight && (
              <span className="px-2 py-1 text-xs font-medium rounded-full bg-[#ff660e] text-white border border-[#ff660e] animate-pulse">
                Filtered
              </span>
            )}
          </div>
          
          <div>
            <p className={`text-2xl font-bold mb-1 ${stat.color} group-hover:text-white transition-colors`}>
              {stat.value.toLocaleString()}
            </p>
            <p className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">{stat.title}</p>
          </div>
          
          {stat.progressBar && pagination.total > 0 && (
            <div className="mt-3">
              <div className="h-1.5 bg-gray-700 rounded-full overflow-hidden">
                <div 
                  className="h-full rounded-full transition-all duration-500"
                  style={{ 
                    width: `${(stats.active / pagination.total) * 100}%`,
                    backgroundColor: '#ff660e'
                  }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                {Math.round((stats.active / pagination.total) * 100)}% Active
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ListingStats;